export const IDENTIFICATIONCODETYPES_RESOURCE = 'identificationCodeTypes';
export const IDENTIFICATIONCODETYPE_RESOURCE = 'identificationCodeType';
export const CREATE_IDENTIFICATIONCODETYPE_RESOURCE = 'createIdentificationCodeType';
export const UPDATE_IDENTIFICATIONCODETYPE_RESOURCE = 'updateIdentificationCodeType';
export const REMOVE_IDENTIFICATIONCODETYPE_RESOURCE = 'removeIdentificationCodeType';

export const INFINITE_SCROLL = { loader: 'blocked' };
export const ACTIONS = {
  ADD: 'add',
  EDIT: 'edit',
};

export const FORM_NAME = 'identificationCodeTypeDetail';
